// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content-split {
  display: flex;
  width: 90%;
  height: 80%;
  max-width: 800px;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.login-image-section, .login-form-section {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.login-form-section{
  /* background-color: #efefef; */
  background-color: rgb(248, 248, 248);
}

.login-form-section h1{
  /* font-family: "Rubrik", sans-serif; */
  font-weight: bold;
}

.login-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.login-title{
  font-family: "Roboto", sans-serif;
  margin-bottom: 20px;
  text-align: center;
}

.login-page-box-shadow .login-title span{
  font-weight: 600;
  color: #9b9b98;
}

.login-input-bg-color{
  background-color: #0b3763;
  width: 90%;
  padding: 25px 20px 20px 20px;
  border-radius: 10px;
  margin-bottom: 20px;
}
.login-input-bg-color input{
  padding: 5px 15px;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 10px;
}
.login-input-bg-color input:focus{
  color: black !important;
}
.login-input-bg-color label{
  color: white;
  font-weight: 600;
  font-size: 17px;
}

.contact-input {
  position: relative;
}

.contact-input .form-message {
  position: absolute;
  left: 0;
  top: 102%;
}

.contact-input .form-message.error {
  color: red;
}

.contact-input .form-message.success {
  color: green;
}

.contact-input h1 {
  font-style: normal;
  font-size: 25px;
  color: #000;
  text-transform: uppercase;
}
.signup-page-heading-text h1{
text-transform: capitalize;
}
.login-page-box-shadow{
  padding: 40px;
  width: 100%;
  margin: 0;
}

.contact-input textarea, .contact-input input {
  width: 100%;
  border: 1.5px solid rgba(90, 113, 132, 0.25);
  box-sizing: border-box;
  border-radius: 8px;
  padding: 15px 20px;
}

.contact-input textarea::placeholder, .contact-input input::placeholder {
  color: #5A7184;
}

.contact-input .contact-btn-wrap button {
  border: none;
}

.login-btn{
  text-align: center;
}
.login-btn button{
  border: none;
  background: none;
}

.login-page-btn{
  padding: 10px 125px;
  /* background-color: #0b3763 !important; */
  background-color: rgb(248, 248, 248);
  font-size: 22px;
  font-weight: 600;
  color: black;
  border-radius: 10px;
  border: 2px solid black;
  transition: all 0.2s ease-in;
  /* width: 80%; */
  /* border:none; */
}
.login-page-btn:hover{
  color: white;
  background-color: #0b3763;
  border: 2px solid transparent;
}

.or-text{
  width: 90%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 17px 0 0 15px;
 }
 .or-text hr{
  flex: 1 1;
  height: 1px;
  color: black;
 }

 .or{ 
  padding: 0px 10px;
}

.google-signin{
  text-align: center;
  padding: 27px 0 27px 0;
}
.google-signin a{
  background-color: rgb(248, 248, 248);
  padding: 15px 60px;
  font-size: 17px;
  font-weight: 600;
  border-radius: 10px ;
  color: #000;
  border: 2px solid black;
  transition: all 0.2s ease-in;
}
.google-signin span{
  font-size: 17px;
}
.google-signin a:hover{
  background-color: rgb(230, 230, 230);
}
.google-signin img{
  width: 30px;
  padding-right: 5px;
  margin-right: 10px;
}

.signup-now{
  text-align: center;
}

@media only screen and (max-width: 767px){
  .modal-content-split{
    width:100%;
    box-shadow: none;
  }
  
  .login-page-box-shadow{
    padding: 40px 0;
  }
  .login-image{
    display: none;
  }
  .login-image-section{
    flex: unset;
    display: unset;
  }
  .login-form-section{
    background: white;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LoginPage/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;AACA;AACA,0BAA0B;AAC1B;AACA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,4CAA4C;EAEpC,sBAAsB;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAcA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;CACtB;CACA;EACC,SAAY;EACZ,WAAW;EACX,YAAY;CACb;;CAEA;EACC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content-split {\n  display: flex;\n  width: 90%;\n  height: 80%;\n  max-width: 800px;\n  background: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.login-image-section, .login-form-section {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-form-section{\n  /* background-color: #efefef; */\n  background-color: rgb(248, 248, 248);\n}\n\n.login-form-section h1{\n  /* font-family: \"Rubrik\", sans-serif; */\n  font-weight: bold;\n}\n\n.login-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.login-title{\n  font-family: \"Roboto\", sans-serif;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.login-page-box-shadow .login-title span{\n  font-weight: 600;\n  color: #9b9b98;\n}\n\n.login-input-bg-color{\n  background-color: #0b3763;\n  width: 90%;\n  padding: 25px 20px 20px 20px;\n  border-radius: 10px;\n  margin-bottom: 20px;\n}\n.login-input-bg-color input{\n  padding: 5px 15px;\n  border-radius: 10px;\n  font-size: 17px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.login-input-bg-color input:focus{\n  color: black !important;\n}\n.login-input-bg-color label{\n  color: white;\n  font-weight: 600;\n  font-size: 17px;\n}\n\n.contact-input {\n  position: relative;\n}\n\n.contact-input .form-message {\n  position: absolute;\n  left: 0;\n  top: 102%;\n}\n\n.contact-input .form-message.error {\n  color: red;\n}\n\n.contact-input .form-message.success {\n  color: green;\n}\n\n.contact-input h1 {\n  font-style: normal;\n  font-size: 25px;\n  color: #000;\n  text-transform: uppercase;\n}\n.signup-page-heading-text h1{\ntext-transform: capitalize;\n}\n.login-page-box-shadow{\n  padding: 40px;\n  width: 100%;\n  margin: 0;\n}\n\n.contact-input textarea, .contact-input input {\n  width: 100%;\n  border: 1.5px solid rgba(90, 113, 132, 0.25);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 8px;\n  padding: 15px 20px;\n}\n\n.contact-input textarea::-webkit-input-placeholder, .contact-input input::-webkit-input-placeholder {\n  color: #5A7184;\n}\n\n.contact-input textarea:-ms-input-placeholder, .contact-input input:-ms-input-placeholder {\n  color: #5A7184;\n}\n\n.contact-input textarea::-ms-input-placeholder, .contact-input input::-ms-input-placeholder {\n  color: #5A7184;\n}\n\n.contact-input textarea::placeholder, .contact-input input::placeholder {\n  color: #5A7184;\n}\n\n.contact-input .contact-btn-wrap button {\n  border: none;\n}\n\n.login-btn{\n  text-align: center;\n}\n.login-btn button{\n  border: none;\n  background: none;\n}\n\n.login-page-btn{\n  padding: 10px 125px;\n  /* background-color: #0b3763 !important; */\n  background-color: rgb(248, 248, 248);\n  font-size: 22px;\n  font-weight: 600;\n  color: black;\n  border-radius: 10px;\n  border: 2px solid black;\n  transition: all 0.2s ease-in;\n  /* width: 80%; */\n  /* border:none; */\n}\n.login-page-btn:hover{\n  color: white;\n  background-color: #0b3763;\n  border: 2px solid transparent;\n}\n\n.or-text{\n  width: 90%;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  margin: 17px 0 0 15px;\n }\n .or-text hr{\n  flex: 1 1 0%;\n  height: 1px;\n  color: black;\n }\n\n .or{ \n  padding: 0px 10px;\n}\n\n.google-signin{\n  text-align: center;\n  padding: 27px 0 27px 0;\n}\n.google-signin a{\n  background-color: rgb(248, 248, 248);\n  padding: 15px 60px;\n  font-size: 17px;\n  font-weight: 600;\n  border-radius: 10px ;\n  color: #000;\n  border: 2px solid black;\n  transition: all 0.2s ease-in;\n}\n.google-signin span{\n  font-size: 17px;\n}\n.google-signin a:hover{\n  background-color: rgb(230, 230, 230);\n}\n.google-signin img{\n  width: 30px;\n  padding-right: 5px;\n  margin-right: 10px;\n}\n\n.signup-now{\n  text-align: center;\n}\n\n@media only screen and (max-width: 767px){\n  .modal-content-split{\n    width:100%;\n    box-shadow: none;\n  }\n  \n  .login-page-box-shadow{\n    padding: 40px 0;\n  }\n  .login-image{\n    display: none;\n  }\n  .login-image-section{\n    flex: unset;\n    display: unset;\n  }\n  .login-form-section{\n    background: white;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
